module.exports = __webpack_public_path__ + "static/media/pharmaflexrx-starter-package.471f298d.png";